module.exports = __webpack_public_path__ + "img/shoushi02.57216268.png";